export class IFdaCenter {
  ndcProductLinkNotAllowed: boolean;
  ndcProductLinkOptional: boolean;
}
